<template>
  <div id="data-view">
    <dv-full-screen-container>
      <top-header/>

      <div class="main-container" :play="playStatus" @playStatus="btmChild">
        <dv-border-box-3 class="left-card-box">
          <div class="card-box-item">
            <Left-Chart/>
          </div>
          <div class="card-box-item">
            <monitoring-list/>
          </div>

        </dv-border-box-3>

        <div class="center-card-box">
          <div class="top-box">
            <dv-border-box-3>
              <Center-Cmp/>
            </dv-border-box-3>
          </div>
          <div class="bottom-box">
            <dv-border-box-8 :dur="10">
              <bottom-map2/>
            </dv-border-box-8>
          </div>
        </div>

        <div class="right-card-box">
          <div class="right-top-box">
            <dv-border-box-13>
              <gather-amount/>
            </dv-border-box-13>
          </div>
          <div class="right-center-box">
            <dv-border-box-13>
              <news-dynamic/>
            </dv-border-box-13>
          </div>
          <div class="right-bottom-box">
            <dv-border-box-13>
              <abnormal-data/>
            </dv-border-box-13>
          </div>
        </div>
      </div>

    </dv-full-screen-container>
  </div>
</template>

<script>
import topHeader from './topHeader'
import LeftChart from './LeftChart'
import CenterCmp from './CenterCmp'
import MonitoringList from './MonitoringList'
// import BottomMap from './BottomMap'
import BottomMap2 from './BottomMap2'
import GatherAmount from './GatherAmount'
import NewsDynamic from './NewsDynamic'
import AbnormalData from './AbnormalData'

export default {
  name: 'DataView',
  components: {
    NewsDynamic,
    topHeader,
    LeftChart,
    CenterCmp,
    MonitoringList,
    BottomMap2,
    GatherAmount,
    AbnormalData
  },
  data() {
    return {
      playStatus: false,
      btmStatus: false
    }
  },
  methods: {
    listChild: function (val) { // B组件自定义事件 状态是布尔值
      this.playStatus = val;
      console.log(this.playStatus);
    },
    btmChild: function (val) { // C组件自定义事件
      this.btmStatus = val;
    }
  },
  mounted() {
    let streetId = this.$route.query.streetId
    if(streetId){
      localStorage.setItem("streetId",streetId+"")
    }else{
      localStorage.removeItem("streetId")
    }
  }
}
</script>

<style scoped lang="less">
#data-view {
  width: 100%;
  height: 100%;
  background-color: #030409;
  color: #fff;

  #dv-full-screen-container {
    background-image: url("/static/img/datav-bg.jpg");
    background-size: 100% 100%;
    box-shadow: 0 0 3px blue;
    display: flex;
    flex-direction: column;
  }

  .main-container {
    height: 90%;
    padding: 0 20px 20px;
    display: flex;
    flex-direction: row;
  }

  .left-card-box {
    width: 25%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 25px;
  }

  .card-box-item {
    width: 100%;
    height: 50%;
  }

  .center-card-box {
    width: 55%;
    height: 100%;

    .top-box {
      width: 100%;
      height: 40%;
    }
  }

  .bottom-box {
    width: 100%;
    height: 60%;
  }

  .right-card-box {
    width: 20%;
    height: 100%;
  }

  .right-top-box {
    width: 100%;
    height: 35%;
  }

  .right-center-box {
    width: 100%;
    height: 35%;
  }

  .right-bottom-box {
    width: 100%;
    height: 30%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/datav/index.vue